/**
 * Applications réelles déjà en production dans l'écosystème OpenMeta.
 * Métadonnées visuelles seulement — les taglines et descriptions bilingues
 * vivent dans `/lib/i18n/{fr,en}.js` sous `applications_data.<id>`.
 *
 * Le champ `screenshot` pointe vers une capture réelle du site (dans
 * /app/frontend/public/apps/). Si absent, la carte retombe sur la
 * vignette « illustration + monogramme » d'origine.
 *
 * ORDRE : les 3 premières apps alimentent le teaser accueil
 * (via `APPLICATIONS.slice(0, 3)` dans ApplicationsTeaser.jsx).
 * Garder aria-radiology + medurgence + atlantys en tête pour conserver
 * le teaser produit (2 santé + 1 social — mix de verticales).
 */
export const APPLICATIONS = [
  {
    id: 'aria-radiology',
    name: 'ARIA Radiology',
    initial: 'A',
    url: 'https://aria-radiology.com',
    verticalCode: 'sante',
    color: '#10B981',
    screenshot: '/apps/aria-radiology.jpg',
  },
  {
    id: 'medurgence',
    name: 'MedUrgence',
    initial: 'M',
    url: 'https://medurgence.fr',
    verticalCode: 'sante',
    color: '#10B981',
    screenshot: '/apps/medurgence.jpg',
  },
  {
    id: 'atlantys',
    name: 'Atlantys',
    initial: 'A',
    url: 'https://atlantys.io/',
    verticalCode: 'social',
    color: '#F97316',
    screenshot: '/apps/atlantys.jpg',
  },
  {
    id: 'medlib',
    name: 'Medlib',
    initial: 'M',
    url: 'https://medlib.app',
    verticalCode: 'sante',
    color: '#10B981',
    screenshot: '/apps/medlib.jpg',
  },
  {
    id: 'medsynapse',
    name: 'MedSynapse',
    initial: 'M',
    url: 'https://medsynapse.org/',
    verticalCode: 'social',
    color: '#F97316',
    screenshot: '/apps/medsynapse.jpg',
  },
  {
    id: 'urgence-pratique',
    name: 'Urgence Pratique',
    initial: 'U',
    url: 'https://urgencepratique.com',
    verticalCode: 'sante',
    color: '#10B981',
    screenshot: '/apps/urgence-pratique.jpg',
  },
  {
    id: 'lexia-school',
    name: 'Lexia School',
    initial: 'L',
    url: 'https://lexia.school/',
    verticalCode: 'langues',
    color: '#F43F5E',
    screenshot: '/apps/lexia.jpg',
  },
];
